import ApplicationInfo from "./Components/ApplicationInfo";

export default ApplicationInfo;
